const TextTransformation = (text) => {
  const textList = {
    // Product Categories
    main_course: 'Main Course',
    drink_dessert_treat: 'Drink or Dessert treat',
    power_side: 'Jumbo Side',
    starters_and_sides: 'Starters & Sides',
    desserts_and_drinks: 'Desserts & drinks',
    party_pack: 'Party pack',
    main_dish: 'Main dish',
    'kids menu': 'Kids menu',
    buy_one_get_one_free: 'Buy 1, Get 1 Free',
    buy_two_get_one_free: 'Buy 2, Get 1 Free',
    buy_one_get_half_price: 'Buy 1,Get 1 Half',
  };

  return textList[text] || text;
};

export default TextTransformation;
